function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9 21.5444C9.90002 21.5444 4 21.5444 4 17.2444C4 12.9444 10 12.9445 11.9 12.9445C13.8 12.9445 19.8 12.9444 19.8 17.2444C19.9 21.5444 13.9 21.5444 11.9 21.5444ZM11.9 14.4445C5.50002 14.4445 5.5 16.5444 5.5 17.2444C5.5 17.9444 5.50002 20.0444 11.9 20.0444C18.3 20.0444 18.3 17.9444 18.3 17.2444C18.4 16.5444 18.4 14.4445 11.9 14.4445Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9 12.2444C8.90002 12.2444 6.59998 9.84446 6.59998 6.94446C6.59998 4.04446 9.00002 1.64441 11.9 1.64441C14.8 1.64441 17.2 4.04446 17.2 6.94446C17.2 9.94446 14.9 12.2444 11.9 12.2444ZM11.9 3.04443C9.80002 3.04443 8 4.74446 8 6.94446C8 9.04446 9.70002 10.8444 11.9 10.8444V11.5444V10.8444C14 10.8444 15.8 9.14446 15.8 6.94446C15.8 4.84446 14.1 3.04443 11.9 3.04443Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9 16.9445C10.2 16.9445 8.90001 15.7445 8.50001 13.8445C8.40001 13.5445 8.60003 13.3445 8.90003 13.2445C9.20003 13.1445 9.40001 13.3445 9.50001 13.6445C9.80001 15.1445 10.7 16.0445 12 16.0445C13.3 16.0445 13.9001 15.4445 14.3001 13.8445C14.4001 13.5445 14.6 13.4445 14.9 13.4445C15.2 13.5445 15.3001 13.7445 15.3001 14.0445C14.8001 16.0445 13.8 16.9445 11.9 16.9445Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9 19.3444C13.6 19.3444 13.4 19.3444 13.1 19.2444C12.3 18.9444 11.5 18.4445 11.5 16.4445C11.5 16.1445 11.7 15.9445 12 15.9445C12.3 15.9445 12.5 16.1445 12.5 16.4445C12.5 17.9445 13 18.1444 13.4 18.2444C14.3 18.5444 14.9 18.0445 15.2 17.4445C15.3 17.1445 15.6 17.0444 15.9 17.1444C16.2 17.2444 16.3 17.5444 16.2 17.8444C15.7 18.6444 14.9 19.3444 13.9 19.3444Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1 18.1444C15.4 18.1444 14.8 17.5444 14.8 16.8444C14.8 16.1444 15.4 15.5444 16.1 15.5444C16.8 15.5444 17.4 16.1444 17.4 16.8444C17.4 17.5444 16.8 18.1444 16.1 18.1444ZM16.1 16.5444C15.9 16.5444 15.8 16.6444 15.8 16.8444C15.8 17.0444 15.9 17.1444 16.1 17.1444C16.3 17.1444 16.4 17.0444 16.4 16.8444C16.4 16.6444 16.2 16.5444 16.1 16.5444Z",
  fill: "white"
});

var SvgStaffing = function SvgStaffing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStaffing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Staffing.62600444.svg";
export { ForwardRef as ReactComponent };